import { serializable, alias, primitive, object } from 'serializr';
import { ClassroomModel } from '../CourseModels/ClassroomModel/classroom.model';
import ChaptorModal from "../ChaptorModel/Chaptor.model";
import { ExamChapterModel } from '../ExamModels/ChapterModel/chapter.model';

export class ExerciseModal {
    @serializable(alias('id', primitive()))
    id?: number;

    @serializable(alias('title', primitive()))
    title?: string;

    @serializable(alias('description', primitive()))
    description?: string;

    @serializable(alias('timer_options', primitive()))
    timerOptions?: string;

    @serializable(alias('time', primitive()))
    time?: Float32Array;

    @serializable(alias('is_active', primitive()))
    isActive?: boolean = false;

    @serializable(alias('position', primitive()))
    position?: number;

    @serializable(alias('chaptor_id', primitive()))
    chaptorId?: number;

    @serializable(alias('class_room_subject', object(ClassroomModel)))
    classRoomSubject?: ClassroomModel;

    @serializable(alias('exam_chapter', object(ExamChapterModel)))
    examChapter?: ClassroomModel;

    @serializable(alias('chaptor', object(ChaptorModal)))
    chaptor?: ChaptorModal;
}
